import { Player } from "../players/models";

export interface RegisterToLeague {
    league: { id: string, season: string, secondPlayerSurname: string, secondPlayerName: string, basePrice: number, isForChildren: boolean };
    city: string;
}

export enum PlayerType {
    REGULAR,
    TRIAL
}

export enum SubscriptionType {
    MONTHLY,
    YEARLY
}

export interface PriceInfo {

    basePrice: number;
    finalPrice: number;

    promoCodeDescription: string;
    promoCode: string;
    promoCodeOk: boolean;

    referralDescription: string;
    referral: string;
    referralOk: boolean;
}

export interface RegistrationData {
    target: RegisterToLeague;
    playerType: PlayerType;
    subscriptionType: SubscriptionType;
    playerData: Player;
    promoCode: string;
    referral: string;
    token: string;
    isUpgrading: boolean;
}

export interface RegistrationStatus {

    isSuccess: boolean;
    paymentLink: string;
    errorMessage: string;
}